import React, { Component } from 'react'
import employees from './Employees'
import FeaturedEmployeRender from './FeaturedEmployeRender'

export default class FeaturedEmployee extends Component {
  render() {
    const employee = shuffle(employees)
      .slice(0, 1)
      .map(item => <FeaturedEmployeRender key={item.id} item={item} />);
    function shuffle(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

    //   While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

    //     And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    }
    return (
      
      <div className='container'>
      <div className='row my-4'>
        <div className="office-parallax parallax d-flex justify-content-center align-items-center col-12">
        <h1 className="main-photo-text">
        Featured employee
        </h1>
      </div>
      </div>
      <div className='row'>
      <div className='card'>
        {employee}
      
      </div>

      </div>
        
      

      </div>
    )
  }
}
